import { Icon } from '@/lib/icons';
import { useCommandPalette } from './context';

export function CommandPaletteTrigger() {
  const { setOpen } = useCommandPalette();
  return (
    <button
      type="button"
      onClick={() => setOpen(true)}
      aria-label="Schnellsuche öffnen"
      className="group flex h-9 w-full items-center gap-2.5 rounded border border-ink-200 bg-ink-50 px-3 text-sm text-ink-500 transition-colors hover:border-ink-300 hover:bg-paper"
    >
      <Icon name="Search" size={16} />
      <span>Suchen …</span>
      <span className="ml-auto inline-flex items-center gap-0.5 text-[10px] text-ink-400">
        <kbd className="rounded border border-ink-200 bg-paper px-1 py-0.5 font-mono">Strg</kbd>
        <kbd className="rounded border border-ink-200 bg-paper px-1 py-0.5 font-mono">K</kbd>
      </span>
    </button>
  );
}
